import { render, staticRenderFns } from "./create-shaded.vue?vue&type=template&id=a1355072&"
import script from "./create-shaded.vue?vue&type=script&lang=js&"
export * from "./create-shaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports